import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Bookmark } from '../../../models/bookmakmodel';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DocumentTemplate } from '../../../models/document-template.model';
import { C } from '@angular/core/src/render3';
import * as _ from 'lodash';
import { async, from } from 'rxjs';


@Component({
  selector: 'app-template-form',
  template: require('./template-form.component.html'),
  styles: [require('./template-form.component.css')]
})
export class TemplateFormComponent implements OnInit {


    bookmarks: Bookmark[] = [];
    templateFormValue: DocumentTemplate;
    applicantForm: FormGroup = new FormGroup({});
    patients: any[];
    providers: any[];
    selectedPatient: any = {};
    selectedProvider: any = {};
    isShowPatient: boolean = false;
    patientId: string;
    cols: number;
    formArr: any[] = [];
    isSendProvider: boolean = false;
    needProvider: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<TemplateFormComponent>,
        private changeDet: ChangeDetectorRef,
        private fb: FormBuilder
    ) {

    }

    ngAfterViewInit() {

    }

    buildFrom() {

    }

    ngOnInit() {
        this.applicantForm = this.fb.group({});

        this.patients = this.data.patients;
        this.providers = this.data.providers;
        this.patientId = this.data.patientId;
        this.templateFormValue = this.data.template;
        this.bookmarks = this.templateFormValue.documentTemplateBookmarks;
        this.selectedPatient = this.patients[0];
        this.selectedProvider = this.data.selectedProvider;
        this.isSendProvider = this.data.isSendProvider;

        var temp = this.bookmarks.filter(i => i.bookmarkPathValue == 'needForm')
        this.bookmarks = temp;
        console.log(this.data);
        this.initData();
       // this.changeDet.detectChanges();

       /* this.cols = _.head(this.bookmarks.sort((a, b) => b.column - a.column)).column;

        var rowCount = _.head(this.bookmarks.sort((a, b) => b.row - a.row)).row;
       
        for (var i = 1; i <= rowCount; i++) {
            for (var j = 1; j <= this.cols; j++) {
                if (!_.some(this.bookmarks, v => v.column == j && v.row == i)) {
                    this.bookmarks.push({ bookmark: 'hidden', column: j, row: i, bookmarkPathValue: 'needForm' } as any);
                }
            }
            
        }
        this.bookmarks = _.sortBy(this.bookmarks, ['row', 'column'])*/
    }

    onSave() {
        if (this.applicantForm.invalid) {
            Object.keys(this.applicantForm.controls).forEach(i => {
                this.applicantForm.controls[i].markAsTouched()
            })
        }
 
        if (!this.isSendProvider && _.isEmpty(this.selectedProvider)) {
            console.log(this.selectedProvider)
            this.needProvider = true;
            return
        }
        this.templateFormValue.documentTemplateBookmarks = this.bookmarks.filter(i => i.bookmark != 'hidden');
        this.dialogRef.close({
            template: this.templateFormValue,
            selectedPatient: this.selectedPatient,
            selectedProvider: this.selectedProvider,
            isHaveValue: true,
        });
    }

    onClose() {
        this.dialogRef.close();
    }

    selectPatient(patient) {
        console.log(patient)
        this.isShowPatient = true;
    }

    initData() {
        

        this.bookmarks.forEach(async (i) => {
            if (i.isRequired) { //need validate field
                this.applicantForm.addControl(i.bookmark, new FormControl('', [Validators.required]))
            }
            if (!_.some(this.formArr, e => e.category == i.category)) {
                if (Boolean(i.category)) {
                    await this.formArr.push({
                        category: i.category,
                        bookmarksTemp: this.bookmarks.filter(s => s.category == i.category)
                    })
                }
            }
        })
        if (_.some(this.bookmarks, e => e.category == '' || e.category == null)) {
            this.formArr.push({
                category: 'No Category',
                bookmarksTemp: this.bookmarks.filter(s => s.category == '' || s.category == null)
            })
        }

        this.formArr.forEach(i => {
            i.bookmarksArr = _.sortBy(this.filterBookmarkFrom(i.bookmarksTemp), ['row', 'column'])
            i.rowCount = i.bookmarksTemp.sort((a, b) => b.row - a.row)[0].row
            i.columnCount = i.bookmarksTemp.sort((a, b) => b.column - a.column)[0].column
        })
        console.log(this.applicantForm.controls)

        console.log(this.formArr)
    }

    filterBookmarkFrom(arr) {
        var supperArr = arr;
        var rowCount = arr.sort((a, b) => b.row - a.row)[0].row
        var columnCounnt = arr.sort((a, b) => b.column - a.column)[0].column  
        for (var i = 1; i <= rowCount; i++) {
            for (var j = 1; j <= columnCounnt; j++) {
                if (!_.some(supperArr, v => v.column == j && v.row == i)) {
                    supperArr.push({ bookmark: 'hidden', column: j, row: i, bookmarkPathValue: 'needForm' } as any);
                }
            }

        }
            //supperArr = _.sortBy(supperArr, ['row', 'cloumn']);
        return supperArr
    }


}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cases-management/template-form/template-form.component.ts